import { mergeBaseUri, mergePaths, parseURI } from '@cian/http-api/shared';

import { filterServerResponse } from './helpers';
import { IRequestToPythonOfferCard, IServerError } from './types';

export interface IRemoveOfferOptions {
  dealType: 'sale' | 'rent';
  offerId: number;
  offerType: 'flat' | 'suburban' | 'commercial';
  subdomain: string;
}

export function removeOffer(requestOptions: IRequestToPythonOfferCard, offerOptions: IRemoveOfferOptions): Promise<{}> {
  const parsedURI = parseURI(requestOptions.pythonOfferCardPublicApi);

  return requestOptions
    .makeRequest({
      body: JSON.stringify(offerOptions),
      method: 'POST',
      withCredentials: true,
      uri: mergeBaseUri(requestOptions.pythonOfferCardPublicApi, {
        path: mergePaths(parsedURI.path, '/v1/delete-offer/'),
      }),
    })
    .then(filterServerResponse)
    .then(response => {
      if (response.responseStatusCode === 204) {
        return {
          status: 'ok',
        };
      }

      throw JSON.parse(response.requestBody) as IServerError;
    });
}
